import axios from 'axios';

const version = 'v1';
const basePath = 'shipment';

export async function getAll({ itemsPerPage, page, ...params }) {
  return axios.request({
    url: `/${version}/${basePath}/list`,
    method: 'get',
    params: {
      order_by: 'id',
      order_mode: 'desc',
      ...(!!itemsPerPage &&
        !!page && {
          limit: itemsPerPage,
          skip: itemsPerPage * (page - 1),
        }),
      ...params,
    },
  });
}

export async function getAllByReferenceOrTracking(number) {
  return axios.request({
    url: `/${version}/${basePath}/list`,
    method: 'get',
    params: {
      order_by: 'id',
      order_mode: 'desc',
      or: `(reference[like]=${number},tracking[like]=${number},order_number[like]=${number})`,
    },
  });
}

export async function getSingle({ reference, id }) {
  return axios.request({
    url: `/${version}/${basePath}/`,
    method: 'get',
    params: {
      id,
      reference,
    },
  });
}

export async function remove(shipments) {
  return axios.request({
    url: `/${version}/${basePath}/`,
    method: 'delete',
    data: {
      shipments,
    },
  });
}

/** @deprecated */
export async function getRetrayable({
  page = 1,
  itemsPerPage = 100,
  ...params
}) {
  return axios.request({
    url: `/${version}/${basePath}/list`,
    method: 'get',
    params: {
      ...params,
      limit: itemsPerPage,
      skip: itemsPerPage * (page - 1),
    },
  });
}

export async function fix(reference, payload) {
  return axios.request({
    url: `/${version}/${basePath}/${reference}/fix`,
    method: 'put',
    data: payload,
  });
}

export async function update(reference, body) {
  return axios.request({
    url: `/${version}/${basePath}/${reference}/update`,
    method: 'put',
    data: { ...body },
  });
}

export async function notManifested() {
  return axios.request({
    url: `/${version}/${basePath}/not-manifested`,
    method: 'get',
  });
}

export async function getRetryableTotals(group_id) {
  return axios.request({
    url: `/${version}/${basePath}/retries`,
    method: 'get',
    params: { group_id },
  });
}
